import {
    ASSIGNED_TO_TAB_REQUEST,
    ASSIGNED_TO_TAB_RESULT,
} from 'Redux/actionTypes';

export const assignedToTabRequest = (data) => ({
    type: ASSIGNED_TO_TAB_REQUEST,
    payload: data
})

export const assignedToTabResult = (data) => ({
    type: ASSIGNED_TO_TAB_RESULT,
    payload: data
})